import api from './axios';

// All authenticated users
export const getBooksApi = (params) => api.get('/books/', { params });
export const getBookDetailApi = (id) => api.get(`/books/${id}/`);
export const initiateBookRequestApi = (data) => api.post('/books/requests/', data);

// Publisher
export const getMyBooksApi = (params) => api.get('/books/my/', { params });
export const createBookApi = (data) =>
  api.post('/books/my/create/', data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateBookApi = (id, data) =>
  api.patch(`/books/my/${id}/`, data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteBookApi = (id) => api.delete(`/books/my/${id}/`);
export const bulkDeleteBooksApi = (ids) => api.post('/books/my/bulk-delete/', { ids });
export const exportMyBooksApi = (params) => api.get('/books/my/export/', { params, responseType: 'blob' });

// Admin
export const adminGetBooksApi = (params) => api.get('/books/admin/', { params });
export const adminCreateBookApi = (data) =>
  api.post('/books/admin/create/', data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const adminUpdateBookApi = (id, data) =>
  api.patch(`/books/admin/${id}/`, data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const adminDeleteBookApi = (id) => api.delete(`/books/admin/${id}/`);
export const adminBulkDeleteBooksApi = (ids) => api.post('/books/admin/bulk-delete/', { ids });
export const toggleBookStatusApi = (id) => api.post(`/books/admin/${id}/toggle-status/`);
export const getBookFilterOptionsApi = () => api.get('/books/filter-options/');
export const getPublisherFilterOptionsApi = () => api.get('/books/publisher-filter-options/');
export const exportBooksApi = (params) => api.get('/books/admin/export/', { params, responseType: 'blob' });

// Admin — book requests
export const getBookRequestsApi = (params) => api.get('/books/requests/admin/', { params });
export const getBookRequestBooksApi = (id, params) => api.get(`/books/requests/admin/${id}/books/`, { params });
export const exportBookRequestBooksApi = (id, params) =>
  api.get(`/books/requests/admin/${id}/export/`, { params, responseType: 'blob' });
